export const trapFocus = (e: KeyboardEvent): void => {
  const currentTarget = e.currentTarget;
  if (!currentTarget || !(currentTarget instanceof HTMLElement)) {
    return;
  }

  const focusable = currentTarget?.querySelectorAll<HTMLElement>(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  const isHidden = (el: HTMLElement) => {
    const style = window.getComputedStyle(el);
    return style.display === 'none';
  };

  const filteredFocusableElements = Array.from(focusable).filter(
    (el) => !isHidden(el)
  );

  const firstFocusableElement = filteredFocusableElements[0];
  const lastFocusableElement =
    filteredFocusableElements[filteredFocusableElements.length - 1];

  if (e instanceof KeyboardEvent) {
    if (e.key === 'Tab') {
      if (e.shiftKey && e.target === firstFocusableElement) {
        e.preventDefault();
        lastFocusableElement?.focus();
      } else if (!e.shiftKey && e.target === lastFocusableElement) {
        e.preventDefault();
        firstFocusableElement?.focus();
      }
    }
  }
};
